module.exports = __webpack_public_path__ + "img/person4.9ddf79c3.webp";